import {ConfirmationModal} from "./confirmation-modal.c";

export const Modal = {
	ConfirmationModal
}
